<template>
    <div>
        <Button
            @click="show = true"
            color="danger"
            iconName="trash"
        >
            Delete Company
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to delete this company?"
            actionText="Yes, delete my company"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    This action can't be reverted.
                </div>
                <ApiForm
                    :url="RoutePathAppEnum.Company_Delete"
                    :disableCatch="false"
                    method="POST"
                    ref="apiFormRef"
                >
                    <FormControl
                        label="Reason"
                        required
                        :error="
                            apiFormRef?.response?.getValidationError(
                                RequestBodyKeyEnum.App_DeleteCompany_Reason,
                            )
                        "
                    >
                        <TextareaInput
                            :name="RequestBodyKeyEnum.App_DeleteCompany_Reason"
                            rows="4"
                            required
                        />
                    </FormControl>
                </ApiForm>
            </template>
        </ModalConfirmation>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextareaInput from '@/Shared/Component/Forms/TextareaInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.catch(() => {
            show.value = false
        })
    }
</script>
